import { EaseChatClient } from '@/IM/initwebsdk'
import { useImConversationStore, useImInfoStore } from '@/store'

export const imConnectListener = () => {
    const mountConnectEventListener = () => {
        EaseChatClient.addEventHandler('connection', {
            onConnected: () => {
                useImConversationStore().getConversationList()
                useImInfoStore().updateConnected(true)
                console.log('环信登录成功')
            },
            onDisconnected: () => {
                useImInfoStore().updateConnected(false)
                console.log('环信退出成功')
            },
            onOnline: () => {
                // 本机网络恢复
            },
            onOffline: () => {
                useImInfoStore().updateConnected(false)
            },
            onError: (error) => {
                console.error('----连接错误----', error)
                useImInfoStore().updateConnected(false)
            }
        })
    }
    return {
        mountConnectEventListener,
    }
}
